// extracted by mini-css-extract-plugin
module.exports = {"label_spec":"report_label_spec__3hCG6","down_spread":"report_down_spread__1tVdj","download_btn":"report_download_btn__hsBTM"};